import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { HaUiCommonModule } from "@ha/ui/common";
import { HaUtilPipesModule } from "@ha/util/pipes";
import { TranslocoModule } from "@ngneat/transloco";
import { NgxsModule } from "@ngxs/store";

import { NotificationHeaderComponent } from "./components/notification-header/notification-header.component";
import { UnreadNotificationsModalComponent } from "./components/notification-header/unread-notifications-modal.component";
import { PushNotificationState } from "./states/push-notification.state";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ServiceWorkerModule,
        TranslocoModule,
        HaUiCommonModule,
        HaUtilPipesModule,
        NgxsModule.forFeature([PushNotificationState]),
    ],
    exports: [NotificationHeaderComponent],
    declarations: [NotificationHeaderComponent, UnreadNotificationsModalComponent],
})
export class PushNotificationModule {}
